var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 15.6655C22.6667 21.6798 23.5324 24.3984 17.7096 24.3984C11.886 24.3984 12.7696 21.6798 12.7696 15.6655",
    stroke: "#E63E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.774 13.3598H11.6611",
    stroke: "#E63E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2864 13.3599C20.2864 13.3599 20.6828 10.5356 17.7171 10.5356C14.7521 10.5356 15.1485 13.3599 15.1485 13.3599",
    stroke: "#E63E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f49f2e1f9a75c3f51efc0d511c8811b0.svg";
export { ForwardRef as ReactComponent };